/** Conflicting addresses refuse the whole selection before any private read. */
export function inboxSelection(params: URLSearchParams) {
  const course=params.get("course")??"";
  const conversation=params.get("conversation")??"";
  const recipient=params.get("recipient")??"";
  const session=params.get("session")??"";
  const channel=params.get("channel")??"all";
  const compose=params.get("compose")==="1"||params.has("recipient");
  const invalid=["course","conversation","recipient","session","compose","channel"].some(key=>params.getAll(key).length>1)
    ||Boolean(conversation&&compose)||!["all","email","chat"].includes(channel)
    ||Boolean(params.has("compose")&&params.get("compose")!=="1");
  return {course,conversation,recipient,session,channel,compose,invalid};
}
